<template lang="pug">

  header(role="banner")
    .layout
      h1
        router-link(to="/") EmojiSpell

</template>
<script>

export default {
  name: 'AppHeader',
};

</script>
